export const GET_SEARCH_INPUT = "GET_SEARCH_INPUT";
export const CLEAR_SEARCH_INPUT = "CLEAR_SEARCH_INPUT";
